import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Grey from '@material-ui/core/colors/grey';

const useStyles = makeStyles((theme) => ({
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        backgroundColor: Grey[500],
    },
    italic: {
        fontStyle: 'italic',
        fontSize: '.75em',
    },
}));

function Disclaimer(){
    const classes = useStyles();

    return (
        <>
        <Divider className={classes.divider} />
        <div className={classes.italic}>
            Each Vacation Section,  Vacation 1-5 as applicable, represents one (1) single vacation bid period requiring entry of multiple bids for each vacation section.  
            Once a vacation bid has been awarded, no other choices in the Vacation Section will be awarded.  You must have an adequate number of bids in each Vacation Section.   
            Once a vacation bid is awarded in a Vacation Section, we will move to the next Vacation Section.  Anyone not turning in their bids or turning in insufficient bids 
            by the deadline will have vacation assigned.</div>
        <Divider className={classes.divider} />
        </>
    );
};

export default Disclaimer;
